import React, { useState, useEffect, useRef, useMemo } from 'react';
import SliderItem from './SliderItem';
import styled from 'styled-components';
import Carousel from 'react-multi-carousel';
import ArrowButtonGroup from './ArrowButtonGroup';
import { media } from 'styled-bootstrap-grid';
import 'react-multi-carousel/lib/styles.css';
import useWindowSize from 'hooks/useWindowSize';
import { getResponsiveBreakpointsSlider } from 'utils/integrations';
const Container = styled.div `
  position: relative;
  padding: ${({ noPadding }) => (noPadding ? 0 : '0 50px')};
  width: ${({ width }) => (width ? width : '100')}px;
  max-width: ${({ width }) => (width ? width : '100')}px;
  box-sizing: border-box;

  ${media.xs `
    padding: 0
  `}

  .react-multi-carousel-list {
    z-index: 1;
  }

  .react-multi-carousel-track {
    padding-top: 4px;
  }
`;
const ProductSlider = ({ products = [], containerWidth, activeProduct, setActiveProduct, }) => {
    const { width: windowWidth } = useWindowSize();
    const [hideArrows, setHideArrows] = useState(false);
    const carouselRef = useRef();
    const responsive = useMemo(() => getResponsiveBreakpointsSlider(windowWidth, containerWidth), [windowWidth, containerWidth]);
    useEffect(() => {
        if (carouselRef === null || carouselRef === void 0 ? void 0 : carouselRef.current) {
            // @ts-ignore
            const slidesToShow = carouselRef.current.state.slidesToShow;
            if (slidesToShow > products.length && !hideArrows) {
                setHideArrows(true);
            }
            else if (slidesToShow <= products.length && hideArrows) {
                setHideArrows(false);
            }
        }
    }, [carouselRef.current, products, windowWidth]);
    return (React.createElement(Container, { noPadding: hideArrows, width: containerWidth },
        React.createElement(Carousel, { ref: (ref) => {
                // @ts-ignore
                carouselRef.current = ref;
            }, responsive: responsive, infinite: true, renderButtonGroupOutside: true, customButtonGroup: React.createElement(ArrowButtonGroup, null), arrows: false }, products.map((product) => (React.createElement(SliderItem, { key: product.id, image: product.image, title: product.title, active: product.id === (activeProduct === null || activeProduct === void 0 ? void 0 : activeProduct.id), onClick: () => setActiveProduct(product) }))))));
};
export default ProductSlider;
